import {createContext, useContext} from 'react'

export const PopoverContext = createContext(null)

export const usePopoverContext = () => {
    const context = useContext(PopoverContext)
    if (!context) {
        throw new Error('usePopoverContext must be used within a Popover component')
    }
    return context
}
